<template>
  <div>
    <div class="item-linew">活动核销信息</div>
    <div class="budgetBox">
      <el-form class="UniformCss">
        <el-row>
          <!-- <el-col :span="7">
            <el-form-item label="核销审核部门">
              <el-input :value="activity.respdeptName" :disabled="true" />
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="上传核销附件">
              <el-input :value="activity.writeOffAnnex" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="核销识别发票">
              <el-input :value="activity.writeOffInvoices" :disabled="true" />
            </el-form-item>
          </el-col> -->
          <el-col :span="18" style="height: auto">
            <el-form-item label="核销规则描述">
              <el-input
                v-model="activity.writeOffRules"
                type="textarea"
                :disabled="Boolean(activity.actplanid)"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 10 }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="18" style="height: auto">
            <el-form-item label="核销材料说明">
              <el-input
                v-model="activity.writeOffMaterial"
                type="textarea"
                :disabled="Boolean(activity.actplanid)"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 10 }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="18" style="height: auto">
            <el-form-item label="核销其他说明">
              <el-input
                v-model="activity.writeOffOther"
                type="textarea"
                :disabled="Boolean(activity.actplanid)"
                maxlength="400"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 10 }"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ['activity'],
  data() {
    return {}
  },
  computed: {},
  created() {
    // console.log(this.activity);
  },
  beforeMount() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="less">
.item-linew {
  margin: 0px;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
</style>
